import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import SignIn from './views/SignIn.vue'
import SignUp from './views/SignUp.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import store, { AUTH_STATE_NOAUTH } from './store'

Vue.use(Router)

const routerConfig = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/sign-in',
      name: 'sign-in',
      component: SignIn
    },
    {
      path: '/sign-up',
      name: 'sign-up',
      component: SignUp
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/about',
      name: 'about',
      component: About
    }
  ]
})

export const identificationRoutes = [
  '/sign-in',
  '/sign-up',
  '/forgot-password'
]

routerConfig.beforeEach((to, from, next) => {
  console.log(to.matched)
  if (
    store.state.authState === AUTH_STATE_NOAUTH &&
    (!identificationRoutes.includes(to.path))
  ) {
    next('/sign-in')
  } else if (to.matched === null || to.matched.length === 0) {
    next('/')
  } else {
    next()
  }
})

export default routerConfig



// WEBPACK FOOTER //
// ./src/router.js